export interface EditorCleanupEntry {
  shortSha: string;
  filePath: string;
}

export function renderEditorCleanupBlock(entry: EditorCleanupEntry): string {
  return [
    `<!-- editor-cleanup: ${entry.shortSha} path=${entry.filePath} -->`,
    `The user edited \`${entry.filePath}\` via the dashboard's WYSIWYG MDX`,
    `editor. The full new file content was committed on this PR branch as`,
    `\`${entry.shortSha}\`.`,
    ``,
    `Please:`,
    `1. \`git show ${entry.shortSha} -- ${entry.filePath}\` to see the diff`,
    `   against its parent.`,
    `2. Identify likely editor artifacts (preserving the user's actual intent):`,
    `   - whitespace-only changes (trailing newlines, leading/trailing spaces`,
    `     in JSX attributes, blank-line additions or removals that don't`,
    `     affect rendering)`,
    `   - JSX attribute reordering or quote-style changes`,
    `   - Frontmatter whitespace or key reordering`,
    `   - Drops of HTML comments the user did not knowingly remove`,
    `3. If you find any: produce ONE follow-up commit "kb: cleanup editor artifacts (#PR)" that fixes only those artifacts. Do not change`,
    `   substantive prose. Push to the same branch.`,
    `4. If the diff looks like a section was accidentally deleted (e.g. the`,
    `   user removed several adjacent paragraphs in one block when the rest`,
    `   of their edits are localized), DO NOT auto-restore — instead post a`,
    `   PR comment flagging it so the reviewer can decide.`,
    `5. If nothing needs cleanup, no-op and do not commit.`,
    `<!-- /editor-cleanup -->`,
  ].join('\n');
}

// Marker shape:
//   <!-- editor-cleanup: <sha> path=<path> -->
// followed by free prose, terminated by:
//   <!-- /editor-cleanup -->
const MARKER_RE =
  /<!--\s*editor-cleanup:\s*([0-9a-f]{4,40})\s+path=([^\s>]+)\s*-->[\s\S]*?<!--\s*\/editor-cleanup\s*-->/g;

export function parseEditorCleanupBlocks(body: string): EditorCleanupEntry[] {
  const out: EditorCleanupEntry[] = [];
  for (const m of body.matchAll(MARKER_RE)) {
    out.push({ shortSha: m[1], filePath: m[2] });
  }
  return out;
}
